import {
  ButtonList,
  DropdownButton,
  DropdownButtonContext,
  Icon,
  Tooltip,
} from '@dixa/lib-shared-habla';
import { SortDirection } from 'lib-shared-types-api';
import { useCallback } from 'react';

type SortOption = {
  key: 'created_at' | 'last_message_created_at';
  label: string;
  direction: SortDirection;
};

export const sortOptions: SortOption[] = [
  {
    key: 'created_at',
    label: 'Created',
    direction: 'desc',
  },
  {
    key: 'created_at',
    label: 'Created',
    direction: 'asc',
  },
  {
    key: 'last_message_created_at',
    label: 'Last message',
    direction: 'desc',
  },
  {
    key: 'last_message_created_at',
    label: 'Last message',
    direction: 'asc',
  },
];

type ConversationTimelineDetailsSortMenuProps = {
  selectedSortOption: SortOption;
  onSelectSortOption: (option: SortOption) => void;
};

export const ConversationTimelineDetailsSortMenu = ({
  selectedSortOption,
  onSelectSortOption,
}: ConversationTimelineDetailsSortMenuProps): JSX.Element => {
  const onSortOptionSelect = useCallback(
    (option: SortOption, toggleDropdown: VoidFunction) => {
      if (selectedSortOption === option) {
        return;
      }

      toggleDropdown();
      onSelectSortOption(option);
    },
    [selectedSortOption, onSelectSortOption],
  );

  return (
    <DropdownButton
      buttonProps={{ variant: 'tertiary' }}
      noArrow
      dropdown={
        <DropdownButtonContext.Consumer>
          {({ toggleDropdown }) => (
            <ButtonList>
              {sortOptions.map((option, idx) => (
                <ButtonList.Item
                  key={idx}
                  isSelected={selectedSortOption === option}
                  onClick={() => onSortOptionSelect(option, toggleDropdown)}
                >
                  {`${option.label}: ${
                    option.direction === 'asc' ? 'Oldest first' : 'Newest first'
                  }`}
                </ButtonList.Item>
              ))}
            </ButtonList>
          )}
        </DropdownButtonContext.Consumer>
      }
      fixed
    >
      <Tooltip
        content={`Sort by: ${selectedSortOption.label}`}
        wrap="div"
        wrapProps={{
          style: { display: 'flex', gap: 'var(--dixa-size-spacer-100)' },
        }}
      >
        <Icon
          name={
            selectedSortOption.direction === 'asc' ? 'filter-z-a' : 'filter-a-z'
          }
        />
      </Tooltip>
    </DropdownButton>
  );
};
